import { render } from "./operat-category.vue?vue&type=template&id=afb12e5e&ts=true"
import script from "./operat-category.vue?vue&type=script&lang=tsx"
export * from "./operat-category.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__